import React, { useEffect } from 'react';
import { identity } from 'lodash';
import { SimpleSidebar } from '@adjust/dashboard-components';
import { SidebarId } from '@react/constants/sidebars';
import { connectWithStore } from '@react/Common/connectWithStore';
import { resetState, fetchUser, saveUserPermissions } from '@redux/ducks/userPermissions/userPermissions';
import { Navigation } from './Navigation';

interface UserPermissionsSidebarOwnProps {
  userId?: string;
  onClose: () => void;
  onSubmit: (email?: string) => void;
}

interface UserPermissionsSidebarDispatchProps {
  fetchUser?: (params) => void;
  resetState?: () => void;
}

type UserPermissionsSidebarProps = UserPermissionsSidebarDispatchProps & UserPermissionsSidebarOwnProps;

export const UserPermissionsSidebarInternalComponent: React.FC<UserPermissionsSidebarProps> = ({
  userId,
  onClose = identity,
  resetState,
  fetchUser,
  onSubmit,
}) => {
  useEffect(() => {
    fetchUser?.(userId);
  }, [userId, fetchUser]);

  const handleClose = () => {
    resetState?.();
    onClose();
  };

  return (
    <SimpleSidebar name={SidebarId.UserPermissions} onClose={handleClose}>
      {({ closeSidebar }) => <Navigation closeSidebar={closeSidebar} onSubmit={onSubmit} />}
    </SimpleSidebar>
  );
};

const mapStateToDispatch = { fetchUser, resetState, onSubmit: saveUserPermissions };

export const UserPermissionsSidebarInternal = connectWithStore(
  null,
  mapStateToDispatch,
)(UserPermissionsSidebarInternalComponent);
